<template>
  <div class="payMentDetails">
    <el-dialog :title="$t('data.payin_details')" :visible.sync="dialogTableVisible" width="580px" class="diglog-card" @open="getDetailInfo">
      <div class="total">
        <div class="total-item">
          <div class="total-title">{{ $t('data.paid') }}:</div>
          <div class="total-num color-main-linear-blue"> {{ $store.getters.currency }}  {{ merchantInfo.transaction_amount | toDivideWithDot }}</div>
        </div>
        <div class="total-item">
          <div class="total-title">{{ $t('data.fee') }}:</div>
          <div class="total-num color-main-linear-blue">{{ $store.getters.currency }}  {{ merchantInfo.fee_split | toDivideWithDot }}</div>
        </div>
      </div>

      <div class="section-title mb-12 mt-12">
        {{ $t('data.timeline') }}
      </div>
      <div class="line-bottom-1px" />
      <div class="item">
        <span class="item-left content-blue">{{ $t('data.payin_created') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_create_time }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.payin_completed') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_return_time }}</span>
      </div>

      <div v-if="merchantInfo.transaction_status === TRANSACTION_STATUS['success']" class="item">
        <span class="item-left content-blue">{{ $t('data.estimated_settlement_time') }}</span>
        <span class="content-gray"><span>{{ merchantInfo.estimated_settlement_time || '/' }}</span></span>
      </div>

      <div v-if="merchantInfo.transaction_status === TRANSACTION_STATUS['success']" class="item">
        <div class="item-left content-blue">{{ $t('data.actual_settlement_time') }}</div>
        <div class="content-gray"><span>{{ merchantInfo.actual_settlement_time || '/' }}</span></div>
      </div>

      <div class="section-title mb-12 mt-36">
        {{ $t('data.description') }}
      </div>
      <div class="line-bottom-1px" />

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.transaction_id') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_id }}</span>
      </div>

      <div v-if="$store.getters.curCountry.country_code === 'TH' && merchantInfo.transaction_status === TRANSACTION_STATUS['void']" class="item">
        <span class="item-left content-blue">{{ $t('customerService.void_transaction_id') }}</span>
        <span class="content-gray">{{ merchantInfo.trans_void_resp && merchantInfo.trans_void_resp.void_no }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.merchant_order_id') }}</span>
        <span class="content-gray">{{ merchantInfo.merchant_order_id }}</span>
      </div>

      <div v-if="merchantInfo.settlement_status && merchantInfo.transaction_status === TRANSACTION_STATUS['success']" class="item">
        <span class="item-left content-blue">{{ $t('data.settlement_status') }}</span>
        <div class="content-gray"> <span> {{ getTransactionSettlementStatusMap( merchantInfo.settlement_status).label }}</span></div>
      </div>

      <div v-if="$store.getters.curCountry.country_code === 'TH' && merchantInfo.transaction_status === TRANSACTION_STATUS['void']" class="item">
        <span class="item-left content-blue">{{ $t('customerService.void_complete_time') }}</span>
        <span class="content-gray">{{ merchantInfo.trans_void_resp && merchantInfo.trans_void_resp.void_complete_time }}</span>
      </div>

      <div v-if="merchantInfo.channel_reference_no" class="item">
        <span class="item-left content-blue">{{ $t($store.getters.isMX ? 'customerService.ph_invoice_no' : 'customerService.invoice_no') }}</span>
        <span class="content-gray">{{ merchantInfo.channel_reference_no }}</span>
      </div>

      <div v-if="[2].includes(merchantInfo.pay_product_type)" class="item">
        <span class="item-left content-blue">{{ $t('customerService.payment_code') }}</span>
        <span class="content-gray">{{ merchantInfo.pay_data }}</span>
      </div>

      <!-- <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.payment_method') }}</span>
        <span class="content-gray">{{ getPayinPaymentMethodMap( merchantInfo.pay_product_type) }}</span>
      </div> -->

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchant.payment_channel') }}</span>
        <span class="content-gray">{{ merchantInfo.channel_code }}</span>
      </div>

      <!-- <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.app_name') }}</span>
        <span class="content-gray">{{ merchantInfo.app_name }}</span>
      </div> -->

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_name') }}</span>
        <span class="content-gray">{{ merchantInfo.payer_name |strAesDecryptAndAsterisk }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_mobile') }}</span>
        <span class="content-gray">{{ merchantInfo.payer_mobile |strAesDecryptAndAsterisk }}</span>
      </div>

      <div v-if="merchantInfo.transaction_status === 2" class="item">
        <span class="item-left content-blue">{{ $t('customerService.refund_type') }}</span>
        <span class="content-gray">{{ getRefundTypeMap(merchantInfo.refund_category) }}</span>
      </div>

      <div v-if="merchantInfo.transaction_status === 2" class="item">
        <span class="item-left content-blue">{{ $t('customerService.cumulative_amount_refunded') }}</span>
        <span class="content-gray">{{ Math.abs(merchantInfo.total_refunded_amount) | toDivideWithDot }}</span>
      </div>

      <div v-if="merchantInfo.transaction_status === 2" class="item">
        <span class="item-left content-blue">{{ $t('customerService.remaining_refundable_order_amount') }}
          <el-tooltip placement="top">
            <div slot="content" style="width: 300px">
              <span>{{ $t('tips.remaining_refundable_amount_tip') }}</span>
            </div>
            <span> <svg-icon icon-class="help-question" class="icon-question" /></span>
          </el-tooltip>
        </span>
        <span class="content-gray">{{ Math.abs(merchantInfo.available_refund_amount) | toDivideWithDot }}</span>

        <el-tag :type="getPayTransactionStatusType(merchantInfo.transaction_status)" class="payin-status tag-custom"> {{ getPayTransactionStatusMap(merchantInfo.transaction_status) }}</el-tag>
      </div></el-dialog>
  </div>
</template>

<script>
import { fetchPayDetail } from '@/api/customer-service/customer-service'
import { payTransactionStatusVoidMap, payinPaymentMethodMap, transactionFeeMode, refundStatusMap } from '@/utils/maps'
import { transactionSettlementStatusMap } from '@/maps/status.js'
export default {
  name: 'Payment_Details_Modal',
  components: {
  },
  props: {
    detailId: {
      type: [Number, String],
      default: '0'
    }
  },
  data() {
    this.TRANSACTION_STATUS = {
      success: 2,
      void: 4
    }
    return {
      dialogTableVisible: false,
      listLoading: false,
      merchantInfo: { merchant: { merchant_basic_info: {}}, payment_fee: {}} // 用户基本信息
    }
  },
  computed: {
    getPayTransactionStatusMap() {
      return function(value) {
        return payTransactionStatusVoidMap(value).label
      }
    },
    getTansationFeeModeLabel() {
      return function(value) {
        return transactionFeeMode(value).label
      }
    },
    getPayTransactionStatusType() {
      return function(value) {
        return payTransactionStatusVoidMap(value).type
      }
    },
    getPayinPaymentMethodMap() {
      return function(value) {
        return payinPaymentMethodMap(value).label
      }
    },
    getTransactionSettlementStatusMap() {
      return function(value) {
        return transactionSettlementStatusMap(value)
      }
    },
    getRefundTypeMap() {
      return function(value) {
        return refundStatusMap(value).label
      }
    }
  },
  mounted() {
  },
  methods: {
    getDetailInfo() {
      const params = { transaction_id: this.detailId }
      fetchPayDetail(params).then(res => {
        this.merchantInfo = res.data
        if (this.merchantInfo.total_refunded_amount === 0) {
          this.merchantInfo.refund_category = null
        }
      })
    },
    // 改变弹框状态
    changModalStatus(value) {
      this.dialogTableVisible = value
    },

    onClickCancal() {
      this.changModalStatus(false)
    }
  }
}
</script>
<style>

</style>

<style scoped lang="scss">
.total{
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  .total-item{
    flex: 1;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid rgba(54, 66, 80, 0.20);
    &:nth-child(1){
      margin-right: 24px;
    }
  }
  &-title{
    color: #364250;
    font-size: 12px;
    font-weight: 600;
  }
  &-num{
    margin-top: 12px;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.2;
    color: #3855F1;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #364250;
}
.content-gray{
  flex: 1;
  text-align: right;
  font-weight: 500;
  font-size: 14px;
  line-height: 15px;
  color: #488CE8;
}

.payMentDetails{
  .payin-status{
    text-align: center;
    position: absolute;
    top: 12px;
    left: 160px;
  }
}

</style>
